import 'jquerymobilecustom';

export default async () => {
  window.$.event.special.tap.tapholdThreshold = 500;
};
